export default "__VITE_ASSET__Bfq1sLoH__"